<div class="fixed inset-0 pointer-events-none z-[9999]">
  @for (position of toastsByPosition.keys(); track position) {
    <div
      class="toast-container fixed flex flex-col pointer-events-auto"
      [ngClass]="getPositionClass(position)"
      [ngStyle]="getPositionStyle(position)"
    >
      @for (toast of toastsByPosition.get(position); track toast.id) {
        <div
          class="toast-item bg-white/50 backdrop-blur-lg rounded-2xl p-4 flex flex-col gap-4 border shadow-sm min-w-[320px] max-w-md mb-3"
          [class.removing]="!toast.visible"
          [@fadeInSlide]="toast.animation === 'fadeInSlide' ? getAnimationState(toast) : undefined"
          [@slide]="toast.animation === 'slide' ? getAnimationState(toast) : undefined"
        >
          <div class="flex items-start justify-between gap-3">
            <div class="flex items-start gap-3">
              <!-- Success Icon -->
              @if (toast.type === 'success') {
                <div
                  class="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0 mt-0.5"
                >
                  <svg
                    class="w-4 h-4 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="3"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
              }

              <!-- Error Icon -->
              @if (toast.type === 'error') {
                <div
                  class="w-6 h-6 rounded-full bg-red-500 flex items-center justify-center flex-shrink-0 mt-0.5"
                >
                  <span class="text-white text-xs font-bold">!</span>
                </div>
              }

              <!-- Warning Icon -->
              @if (toast.type === 'warning') {
                <div class="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg class="w-6 h-6 text-orange-500" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M12 2L1 21h22L12 2zm0 4l7.53 13H4.47L12 6zm-1 5v4h2v-4h-2zm0 6v2h2v-2h-2z"
                    />
                  </svg>
                </div>
              }

              <!-- Info Icon -->
              @if (toast.type === 'info') {
                <div
                  class="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5"
                >
                  <span class="text-white text-xs font-bold">i</span>
                </div>
              }

              <p class="text-gray-800 text-sm font-medium">{{ toast.message }}</p>
            </div>

            <button
              class="text-gray-400 hover:text-gray-600 flex-shrink-0"
              (click)="dismiss(toast.id)"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>

          @if (toast.actions && toast.actions.length > 0) {
            <div class="flex items-center gap-3">
              @for (action of toast.actions; track action.label) {
                <button
                  [ngClass]="getActionButtonClass(toast.type, action.primary || false)"
                  (click)="handleAction(toast, action.handler)"
                >
                  {{ action.label }}
                </button>
              }
              <button
                class="text-gray-500 hover:text-gray-700 text-sm font-medium px-4 py-2.5 transition-colors"
                (click)="dismiss(toast.id)"
              >
                Cerrar
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
